import app from 'flarum/forum/app';
import Page, { IPageAttrs } from 'flarum/common/components/Page';
import ScheduledPostsList from './ScheduledPostsList';
import extractText from 'flarum/common/utils/extractText';
import type Mithril from 'mithril';

export default class ScheduledPostsPage<CustomAttrs extends IPageAttrs = IPageAttrs> extends Page<CustomAttrs> {
	oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
		super.oninit(vnode);

		app.history.push('scheduled_posts', extractText(app.translator.trans('glowingblue-scheduled-posts.forum.page.title')));

		app.scheduledPosts.load();

		this.bodyClass = 'App--scheduled-posts';
	}

	view() {
		return (
			<div className="ScheduledPostsPage">
				<ScheduledPostsList state={app.scheduledPosts} />
			</div>
		);
	}
}
